import { jsx } from "panel";
import { ModalEl } from "common/components/modal";
import { SpinnerEl } from "common/components/spinner";
import { SpinnerColor, SpinnerSize } from "common/components/spinner/types";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { DatasetCardEl } from "./dataset";
export function template() {
  return /* @__PURE__ */ jsx(ModalEl, { sel: ".mp-demo-selector-modal", attrs: {
    closeable: true,
    open: true,
    "grow-to-content": true
  }, "data-sentry-element": "ModalEl", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx("div", { sel: ".mp-modal-large-content" }, /* @__PURE__ */ jsx("div", { sel: ".header" }, this.attr("is-fyt") ? this.t("help.demo-loading") : this.t("help.demo-select-dataset")), /* @__PURE__ */ jsx("div", { sel: ".mp-modal-text" }, this.attr("is-fyt") ? /* @__PURE__ */ jsx(null, null, this.t("help.demo-request-title"), /* @__PURE__ */ jsx("div", null, this.t("help.demo-request-owner", {
    ownerEmail: this.attr("owner-email")
  }))) : this.t("help.demo-switch-tip")), /* @__PURE__ */ jsx("div", { sel: ".modal-container" }, this.state.loadingProjects ? /* @__PURE__ */ jsx("div", { sel: ".spinner-wrapper" }, /* @__PURE__ */ jsx(SpinnerEl, { attrs: {
    color: SpinnerColor.Blue,
    size: SpinnerSize.Large
  } })) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".datasets-wrapper" }, this.state.demoProjects.map((project) => /* @__PURE__ */ jsx(DatasetCardEl, { attrs: {
    "img-name": project.icon,
    text: project.description,
    "project-id": project.projectId,
    selected: this.state.selectedDemo === project.description
  }, on: {
    click: () => this.helpers.clickedDataset(project.description)
  } }))), /* @__PURE__ */ jsx("div", { sel: ".explore-demo-button" }, /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    elref: "submitButton",
    theme: ButtonTheme.Primary,
    disabled: !this.state.selectedDemo || this.state.waitingOnResponse
  }, on: {
    click: () => this.helpers.clickedExploreDemoButton()
  } }, this.state.waitingOnResponse ? /* @__PURE__ */ jsx(SpinnerEl, { attrs: {
    color: SpinnerColor.White
  } }) : this.t("help.demo-cta"))))))));
}
